import {Router, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {ConfigService} from '../../core/services/config.service';

/**
 * Schützt alle Widerruf-Routen (revocation, revocation/new, revocation-without-login).
 * Die Routen sind nur erreichbar, wenn die Vorgabe 'revocation.enabled' auf '1' steht.
 * Ist die Vorgabe nicht gesetzt oder != '1', wird auf die Startseite umgeleitet.
 *
 * Hinweis: canActivate läuft VOR dem ConfigResolverService, daher wird die Vorgabe hier
 * via loadConfig() selbst (asynchron, gecacht) geladen statt über das synchrone getConfig().
 */
@Injectable({providedIn: 'root'})
export class RevocationGuard {
  private readonly configService = inject(ConfigService);
  private readonly router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> {
    return this.configService.loadConfig('revocation.enabled').pipe(map(config => {
      if (config?.value === '1') {
        return true;
      }
      return this.router.createUrlTree(['/']);
    }));
  }
}
